import React, {useEffect, useState} from "react";
import Box from '@mui/material/Box';
import Badge from '@mui/material/Badge';
import MailIcon from '@mui/icons-material/Mail';
import {API} from "../../API";

export default function InboxIcon(props) {
  const [numberOfUnreadMessages, setNumberOfUnreadMessages] = useState(0)

  useEffect(() => {
    API.getNumberOfUnreadMaterialMessage()
      .then((res) => {
        setNumberOfUnreadMessages(res.data.unread_count)
        // console.log(res.data.unread_count)
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <Box className="inbox-icon-container pt-1" sx={{color: 'white'}}>
      <a
        href={props.role === "teacher" ? "InboxCustomer" : "Inbox"}
        style={{ color: "white" }}
      >
        <Badge
          color="primary"
          variant={numberOfUnreadMessages >= 1 ? "dot" : ""}
        >
          <MailIcon />
        </Badge>
      </a>
    </Box>
  );
}